import findKey from 'lodash/findKey';
import tenants from './tenants';
import { ITenantConfig } from '@framework/tenant/vo/TenantConfig';
import isServer from '@framework/router/Next/isServer';

/**
 * This class represents config of tenant. It includes all properties you can find in config.tenant[{code}]
 */
class TenantConfig {
  constructor(tenantConfig: ITenantConfig) {
    // Copy all properties to this object
    Object.assign(this, tenantConfig);
  }

  // TODO: Type casting is used now. In the future we need to bring every tenant config to the same ITenantConfig type.
  private static tenantConfig: {
    [key: string]: ITenantConfig,
  } = tenants as unknown as {
    [key: string]: ITenantConfig,
  };

  static fromCode(code: string) {
    const tenantKey = findKey(this.tenantConfig, (tenant) => tenant.code === code);
    if (typeof tenantKey === 'undefined') {
      throw new Error(`Tenant ${ code } not found`);
    }
    return new TenantConfig(this.tenantConfig[tenantKey]) as ITenantConfig;
  }

// @ts-ignore TODO: FIN-32798 strictNullChecks
  static fromHostname(hostname: string = isServer() ? undefined : window.location.hostname) {
    if (!this.exists(hostname)) {
      throw new Error(`Tenant not found, hostname: ${ hostname }`);
    }
    return new TenantConfig(
// @ts-ignore TODO: FIN-32798 strictNullChecks
      this.tenantConfig[findKey(this.tenantConfig, (tenant) => tenant.hostname === hostname)],
    ) as ITenantConfig;
  }

  static fromObject(object: ITenantConfig) {
    return new TenantConfig(object) as ITenantConfig;
  }

  /**
   * Checks whether tenant exists for specific hostname
   * @param {String} hostname
   * @return {boolean}
   */
// @ts-ignore TODO: FIN-32798 strictNullChecks
  static exists(hostname: string = isServer() ? undefined : window.location.hostname) {
// @ts-ignore TODO: FIN-32798 strictNullChecks
    return !!this.tenantConfig[findKey(this.tenantConfig, (tenant) => tenant.hostname === hostname)];
  }

  static validateTenant(tenantCode: string): string | null {
    if (!tenantCode) return null;
    const tenantKey = findKey(this.tenantConfig, (tenant) => tenant.code === tenantCode);
    return tenantKey ? tenantCode : null;
  }
}

export default TenantConfig;
